// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import { WEIGHT_UNITS } from '@seedplanner/shared-utils';

export const formatWeightUnits = (weight: number, unit?: string | null) => {
  const isPlural = weight > 1;
  let units = unit;
  if (!isPlural) {
    if (unit === WEIGHT_UNITS.OUNCES) {
      units = 'ounce';
    } else if (unit === WEIGHT_UNITS.GRAMS) {
      units = 'gram';
    }
  }

  return `${weight} ${units ?? ''}`;
};

export const shortenWeightUnit = (unit: string) => {
  if (unit === WEIGHT_UNITS.OUNCES) {
    return 'oz';
  }
  if (unit === WEIGHT_UNITS.GRAMS) {
    return 'g';
  }
  return unit;
};
